import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'icon-action',
    styles: [`
        div {
            padding: 4px;
        }
        div.hover {
            background-color: #363636 !important;
        }
        i {
            color: #8e8e8e;
            display: block;
        }
        a {
            color: #8e8e8e !important;
        }
    `],
    template: `
    <div style="text-align: center;"
        [ngClass]="{ 'hover': hover }"
        (mouseover)="onMouseOver()"
        (mouseout)="onMouseOut()">
        <a href="#">
            <i class="zmdi zmdi-{{icon}}" [style.font-size]="size"></i>
            <div>{{ title }}</div>
        </a>
    </div>
    `
})
export class IconActionComponent implements OnInit {
    @Input() icon: string;
    @Input() title: string;
    @Input() size: string;

    public hover: boolean;

    ngOnInit() {
        switch (this.size) {
            case 'small':
                this.size = '36px';
                break;
            case 'big':
                this.size = '48px';
                break;
            case 'huge':
                this.size = '72px';
                break;
            default:
                this.size = '24px';
        }
    }

    public onMouseOver() {
        this.hover = true;
    }

    public onMouseOut() {
        this.hover = false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/icon-action/icon-action.component.ts